import React from "react";
import { Loader } from "@arcadis/novus-design-system";
import { LoaderComponentStyles } from "../variants";

function LoaderComponent() {
    return <Loader {...LoaderComponentStyles} />;
}

export default LoaderComponent;
